import { render, staticRenderFns } from "./InsolvencyAttachments.vue?vue&type=template&id=793f5c49&scoped=true&"
import script from "./InsolvencyAttachments.vue?vue&type=script&lang=js&"
export * from "./InsolvencyAttachments.vue?vue&type=script&lang=js&"
import style0 from "./InsolvencyAttachments.vue?vue&type=style&index=0&id=793f5c49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793f5c49",
  null
  
)

export default component.exports